import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { COMMON_PERMISSIONS } from '../utils/helper';

const useSubModulePermissionCheck = (module, submodule) => {
  // Since we removed workspace slice, provide a fallback for permissionsData
  const permissionsData = {}; // Empty object as fallback

  // Return empty array as fallback since permissions are not available
  return [];
};

export default useSubModulePermissionCheck;
